import { TMessage } from "@/i18n/tt";
import { TMessageKey } from "@/i18n/types.gen";

export enum FilterKeys {
  ALL_TRANSACTIONS = "allTransactions",
  TRANSFER = "transfer",
  ISSUE = "issueOrIncrease",
  SPLIT = "split",
  CAPITAL_REDUCTION = "reduction-capital",
  DIVIDEND = "dividend",
}

export const filterKeyLabels: { [key in FilterKeys]: TMessageKey } = {
  [FilterKeys.ALL_TRANSACTIONS]: "transactions.allTransactions",
  [FilterKeys.TRANSFER]: "transactions.transfer",
  [FilterKeys.ISSUE]: "transactions.issueOrIncrease",
  [FilterKeys.SPLIT]: "transactions.split",
  [FilterKeys.CAPITAL_REDUCTION]: "transactions.reduction-capital",
  [FilterKeys.DIVIDEND]: "transactions.dividend",
};

export enum TransactionType {
  AUTOIMPORT = "AUTOIMPORT",
  ISSUE = "ISSUE",
  INCORPORATION = "INCORPORATION",
  BUY_SELL = "BUY_SELL",
  GIFT = "GIFT",
  INHERITANCE = "INHERITANCE",
  OTHER_TRANSFER = "OTHER_TRANSFER",
  SPLIT = "SPLIT",
  REVERSE_SPLIT = "REVERSE_SPLIT",
  INCREASE_NOMINAL_VALUE = "INCREASE_NOMINAL_VALUE",
  CANCELLATION_OF_SHARES = "CANCELLATION_OF_SHARES",
  REDUCTION_NOMINAL_VALUE = "REDUCTION_NOMINAL_VALUE",
  PAY_DIVIDEND = "PAY_DIVIDEND",
  GROUP_CONTRIBUTION = "GROUP_CONTRIBUTION",
  CONVERSION_OF_SHARES = "CONVERSION_OF_SHARES",
  CONVERSION_FROM_ISIN = "CONVERSION_FROM_ISIN",
  SHAREHOLDING_PER_DATE = "SHAREHOLDING_PER_DATE",
  OWNERS_PER_DATE = "OWNERS_PER_DATE",
  LIQUIDATION = "LIQUIDATION",
  MERGER = "MERGER",
  DEMERGER = "DEMERGER",
  COMPANY_STATUS_CHANGE = "COMPANY_STATUS_CHANGE",
}

export const transactionTypeLabels: { [key in TransactionType]: TMessageKey } = {
  [TransactionType.AUTOIMPORT]: "AUTOIMPORT",
  [TransactionType.ISSUE]: "ISSUE",
  [TransactionType.INCORPORATION]: "INCORPORATION",
  [TransactionType.BUY_SELL]: "BUY_SELL",
  [TransactionType.GIFT]: "GIFT",
  [TransactionType.INHERITANCE]: "INHERITANCE",
  [TransactionType.OTHER_TRANSFER]: "OTHER_TRANSFER",
  [TransactionType.SPLIT]: "SPLIT",
  [TransactionType.REVERSE_SPLIT]: "REVERSE_SPLIT",
  [TransactionType.INCREASE_NOMINAL_VALUE]: "INCREASE_NOMINAL_VALUE",
  [TransactionType.CANCELLATION_OF_SHARES]: "CANCELLATION_OF_SHARES",
  [TransactionType.REDUCTION_NOMINAL_VALUE]: "REDUCTION_NOMINAL_VALUE",
  [TransactionType.PAY_DIVIDEND]: "PAY_DIVIDEND",
  [TransactionType.GROUP_CONTRIBUTION]: "GROUP_CONTRIBUTION",
  [TransactionType.CONVERSION_OF_SHARES]: "CONVERSION_OF_SHARES",
  [TransactionType.CONVERSION_FROM_ISIN]: "CONVERSION_FROM_ISIN",
  [TransactionType.SHAREHOLDING_PER_DATE]: "SHAREHOLDING_PER_DATE",
  [TransactionType.OWNERS_PER_DATE]: "OWNERS_PER_DATE",
  [TransactionType.LIQUIDATION]: "LIQUIDATION",
  [TransactionType.MERGER]: "MERGER",
  [TransactionType.DEMERGER]: "DEMERGER",
  [TransactionType.COMPANY_STATUS_CHANGE]: "COMPANY_STATUS_CHANGE",
};

export const transactionLabel: { [key in TransactionType]: TMessage } = {
  [TransactionType.AUTOIMPORT]: { key: "AUTOIMPORT" },
  [TransactionType.ISSUE]: { key: "ISSUE" },
  [TransactionType.INCORPORATION]: { key: "INCORPORATION" },
  [TransactionType.BUY_SELL]: { key: "BUY_SELL" },
  [TransactionType.GIFT]: { key: "GIFT" },
  [TransactionType.INHERITANCE]: { key: "INHERITANCE" },
  [TransactionType.OTHER_TRANSFER]: { key: "OTHER_TRANSFER" },
  [TransactionType.SPLIT]: { key: "SPLIT" },
  [TransactionType.REVERSE_SPLIT]: { key: "REVERSE_SPLIT" },
  [TransactionType.INCREASE_NOMINAL_VALUE]: { key: "INCREASE_NOMINAL_VALUE" },
  [TransactionType.CANCELLATION_OF_SHARES]: { key: "CANCELLATION_OF_SHARES" },
  [TransactionType.REDUCTION_NOMINAL_VALUE]: { key: "REDUCTION_NOMINAL_VALUE" },
  [TransactionType.PAY_DIVIDEND]: { key: "PAY_DIVIDEND" },
  [TransactionType.GROUP_CONTRIBUTION]: { key: "GROUP_CONTRIBUTION" },
  [TransactionType.CONVERSION_OF_SHARES]: { key: "CONVERSION_OF_SHARES" },
  [TransactionType.CONVERSION_FROM_ISIN]: { key: "CONVERSION_FROM_ISIN" },
  [TransactionType.SHAREHOLDING_PER_DATE]: { key: "SHAREHOLDING_PER_DATE" },
  [TransactionType.OWNERS_PER_DATE]: { key: "OWNERS_PER_DATE" },
  [TransactionType.LIQUIDATION]: { key: "LIQUIDATION" },
  [TransactionType.MERGER]: { key: "MERGER" },
  [TransactionType.DEMERGER]: { key: "DEMERGER" },
  [TransactionType.COMPANY_STATUS_CHANGE]: { key: "COMPANY_STATUS_CHANGE" },
};
